import { QDialog } from "quasar";
import { defineComponent, ref, computed, onUnmounted, createElementBlock, openBlock, Fragment, createVNode, createBlock, createElementVNode, withCtx } from "vue";
import { RichTextEditor } from "@editor/ui-richtext";
import { useWordCountStore } from "@editor/ui-utils";
import { TableOfContentsInput, LinkEntitiesView } from "@modules/news-article-editor-ui";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "text-content-block",
  props: {
    block: { type: Object, required: true, default: () => ({ content: "<p></p>", type: "TEXT" }) },
    locked: { type: Boolean, required: true, default: false },
    brand: { type: String, required: true }
  },
  emits: ["update:block", "wordCharUpdate"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props = __props;
    const emit = __emit;
    const editor = ref(void 0);
    const localBlock = computed({
      get: () => props.block,
      set: (newValue) => emit("update:block", newValue)
    });
    const showDialog = ref(false);
    const refreshCounter = ref(0);
    const words = ref(0);
    const characters = ref(0);
    const wordCountStore = useWordCountStore();
    const textToPassToPicker = ref("");
    const storeObservable = computed(() => ({
      wordCharCount: {
        words: words.value,
        characters: characters.value
      }
    }));
    const toggleLinkEntitiesDialog = (highlightedText) => {
      textToPassToPicker.value = highlightedText;
      showDialog.value = !showDialog.value;
    };
    function insertLink(e) {
      var _a, _b;
      if (!editor.value) {
        console.warn("Editor reference is not set.");
        return;
      }
      if (textToPassToPicker.value !== "") {
        (_a = editor.value) == null ? void 0 : _a.addLinkToExistingText(e.linkHref);
      } else {
        (_b = editor.value) == null ? void 0 : _b.insertLinkAtMousePosition(e.content, e.linkHref);
      }
    }
    const wordCharUpdate = (a) => {
      const diff = {
        words: a.words - words.value,
        characters: a.characters - characters.value
      };
      emit("wordCharUpdate", diff);
      words.value = a.words;
      characters.value = a.characters;
    };
    wordCountStore.onMount(storeObservable);
    onUnmounted(() => {
      wordCountStore.onUnmount(storeObservable);
    });
    const __returned__ = { props, emit, editor, localBlock, showDialog, refreshCounter, words, characters, wordCountStore, textToPassToPicker, storeObservable, toggleLinkEntitiesDialog, insertLink, wordCharUpdate, get RichTextEditor() {
      return RichTextEditor;
    }, get LinkEntitiesView() {
      return LinkEntitiesView;
    }, get TableOfContentsInput() {
      return TableOfContentsInput;
    }, get QDialog() {
      return QDialog;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1 = { class: "q-mt-md q-mb-sm" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      createVNode($setup["TableOfContentsInput"], {
        modelValue: $setup.localBlock.tableOfContentsText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.localBlock.tableOfContentsText = $event),
        disabled: $props.locked,
        readonly: $props.locked
      }, null, 8, ["modelValue", "disabled", "readonly"]),
      (openBlock(), createBlock($setup["RichTextEditor"], {
        key: $setup.refreshCounter,
        ref: "editor",
        modelValue: $setup.localBlock.content,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.localBlock.content = $event),
        "data-qa-article-content-text-block-textarea": "",
        style: { "white-space": "break-spaces" },
        disabled: $props.locked,
        readonly: $props.locked,
        "enable-link-entities-plugin": true,
        onWordCharUpdate: $setup.wordCharUpdate,
        onToggleLinkEntitiesDialog: $setup.toggleLinkEntitiesDialog
      }, null, 8, ["modelValue", "disabled", "readonly"])),
      createElementVNode("div", _hoisted_1, [
        createVNode($setup["QDialog"], {
          modelValue: $setup.showDialog,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $setup.showDialog = $event),
          "data-qa-list-tags-dialog": "",
          "full-width": "",
          "full-height": ""
        }, {
          default: withCtx(() => [
            createVNode($setup["LinkEntitiesView"], {
              "show-dialog": $setup.showDialog,
              brand: $props.brand,
              "highlighted-text": $setup.textToPassToPicker,
              onClose: _cache[2] || (_cache[2] = ($event) => $setup.showDialog = false),
              "onClick:entity": $setup.insertLink
            }, null, 8, ["show-dialog", "brand", "highlighted-text"])
          ]),
          _: 1
          /* STABLE */
        }, 8, ["modelValue"])
      ])
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const TextContentBlockComponent = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/news-article/editor-ui-article-content-text/src/blocks/text-content-block.vue"]]);
const textContentBlockModule = {
  messages: {
    en: { contentBlocks: { text: "Text field" } },
    de: { contentBlocks: { text: "Textfeld" } }
  },
  routes: [],
  contentBlocks: [
    {
      type: "TEXT",
      label: "contentBlocks.text",
      icon: "align-left",
      component: TextContentBlockComponent,
      defaultValue: { content: "<p></p>" }
    }
  ]
};
export {
  textContentBlockModule
};
//# sourceMappingURL=index.es.js.map
